/**
 * @generated SignedSource<<e60776eb0ca1d79ddf3a1b9b380f3719>>
 * @lightSyntaxTransform
 * @nogrep
 */
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
import { ConcreteRequest } from 'relay-runtime';

export type TaskError = 'TASK_NOT_FOUND' | '%future added value';
export type TaskStatus =
  | 'CANCELLED'
  | 'DISPATCHED'
  | 'DISPATCHED_FAILED'
  | 'FAILED'
  | 'NOT_FOUND'
  | 'SCHEDULED'
  | 'STARTED'
  | 'SUCCEEDED'
  | '%future added value';
export type usePollStatusQuery$variables = {
  id: string;
};
export type usePollStatusQuery$data = {
  readonly task: {
    readonly data: {
      readonly id: string;
      readonly status: TaskStatus;
    } | null;
    readonly errors: ReadonlyArray<TaskError>;
  };
};
export type usePollStatusQuery = {
  response: usePollStatusQuery$data;
  variables: usePollStatusQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'TaskValidation',
        kind: 'LinkedField',
        name: 'task',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            concreteType: 'Task',
            kind: 'LinkedField',
            name: 'data',
            plural: false,
            selections: [
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'id',
                storageKey: null,
              },
              {
                alias: null,
                args: null,
                kind: 'ScalarField',
                name: 'status',
                storageKey: null,
              },
            ],
            storageKey: null,
          },
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'errors',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'usePollStatusQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'usePollStatusQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '39d166c2e7873678c23a0dff55eee470',
      id: null,
      metadata: {},
      name: 'usePollStatusQuery',
      operationKind: 'query',
      text: 'query usePollStatusQuery(\n  $id: String!\n) {\n  task(id: $id) {\n    data {\n      id\n      status\n    }\n    errors\n  }\n}\n',
    },
  };
})();

(node as any).hash = 'fb10d4afa7f04a586e3ca6706ec6cfec';

export default node;
